/**
 * Office finder search: filters the map's pins as the visitor types.
 */
( function() {
	const forms = document.querySelectorAll( '[data-wgi-location-search]' );

	if ( ! forms.length ) {
		return;
	}

	/**
	 * What was typed, as the words to look for.
	 *
	 * @param {string} value The field's value.
	 * @return {string[]} Lower-cased words.
	 */
	function termsOf( value ) {
		return value.trim().toLowerCase().split( /\s+/ ).filter( Boolean );
	}

	/**
	 * Whether a haystack carries every one of the words.
	 *
	 * @param {string}   haystack Lower-cased text.
	 * @param {string[]} terms    The words.
	 * @return {boolean} True when they are all there — and when there are none.
	 */
	function matches( haystack, terms ) {
		return terms.every( function( term ) {
			return haystack.includes( term );
		} );
	}

	/**
	 * Fill a printf-style template the PHP side handed over.
	 *
	 * @param {string} template The template.
	 * @param {Object} values   Keyed by the placeholder, `%1$d` and the like.
	 * @return {string} The text.
	 */
	function fill( template, values ) {
		return Object.keys( values ).reduce( function( text, key ) {
			return text.split( key ).join( String( values[ key ] ) );
		}, template || '' );
	}

	forms.forEach( function( form ) {
		const input = form.querySelector( 'input[name="find"]' );
		const count = form.querySelector( '[data-wgi-location-count]' );
		const empty = form.querySelector( '[data-wgi-location-empty]' );
		const canvas = form.dataset.map ? document.querySelector( form.dataset.map ) : null;

		if ( ! input || ! canvas ) {
			return;
		}

		let api = null;
		let cards = [];

		/**
		 * Take up the map once it is there.
		 *
		 * @param {Object} ready The API map.js leaves on the canvas.
		 */
		function connect( ready ) {
			api = ready;

			cards = api.places.map( function( place ) {
				return place.card;
			} );
		}

		/**
		 * Go without a map.
		 */
		function disconnect() {
			api = null;
			cards = Array.from( canvas.querySelectorAll( '[data-wgi-map-place]' ) );
		}

		if ( canvas.wgiMap ) {
			connect( canvas.wgiMap );
		} else {
			disconnect();
		}

		canvas.addEventListener( 'wgi-map:ready', function( event ) {
			connect( event.detail );
		} );

		canvas.addEventListener( 'wgi-map:removed', disconnect );

		/**
		 * Say how many offices are showing.
		 *
		 * @param {number}   shown How many match.
		 * @param {string[]} terms What was searched for.
		 */
		function say( shown, terms ) {
			if ( ! count ) {
				return;
			}

			const total = cards.length;
			const query = input.value.trim();

			if ( ! terms.length ) {
				count.textContent = fill( 1 === total ? form.dataset.countOne : form.dataset.countMany, { '%d': total } );
			} else if ( ! shown ) {
				count.textContent = fill( form.dataset.countNone, { '%s': query } );
			} else {
				count.textContent = fill( form.dataset.countSome, { '%1$d': shown, '%2$d': total, '%3$s': query } );
			}
		}

		/**
		 * Keep the address bar in sync with the search.
		 */
		function remember() {
			const url = new URL( window.location.href );
			const query = input.value.trim();

			if ( query ) {
				url.searchParams.set( 'find', query );
			} else {
				url.searchParams.delete( 'find' );
			}

			window.history.replaceState( null, '', url );
		}

		/**
		 * Run the search over the map.
		 */
		function apply() {
			const terms = termsOf( input.value );

			let shown = 0;

			cards.forEach( function( card ) {
				const hit = matches( card.dataset.search || '', terms );

				if ( hit ) {
					shown++;
				}

				if ( api ) {
					api.show( card.dataset.id, hit );
				} else {
					card.hidden = ! hit;
				}
			} );

			if ( empty ) {
				empty.hidden = shown > 0;
			}

			say( shown, terms );
			remember();

			if ( ! api ) {
				return;
			}

			api.close();
			api.fit();
		}

		let timer;

		input.addEventListener( 'input', function() {
			window.clearTimeout( timer );
			timer = window.setTimeout( apply, 150 );
		} );

		// WebKit fires `search` when the field is cleared.
		input.addEventListener( 'search', apply );

		form.addEventListener( 'submit', function( event ) {
			event.preventDefault();
			window.clearTimeout( timer );
			apply();
		} );
	} );
}() );
